import { Typography } from "@mui/material";
import { appName } from "../../constants/common";

const Footer = ({ ...props }) => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      © {new Date().getFullYear()} {appName}. All rights reserved.
    </Typography>
  );
};

export default Footer;
